import { getQueueStats } from '@/services/webchat-service/webchat.service';
import { QueueStats } from '@/services/webchat-service/webchat.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useWebchatQueueStats = () => {
  const { data: queueStats, isPending } = useQuery<QueueStats>({
    queryKey: ReactQueryKeys.WEBCHAT_QUEUE_STATS(),
    queryFn: getQueueStats,
    refetchInterval: 15_000,
  });

  return { queueStats, isPending };
};
